const SET_ITEMS = (state, obj) => {
  state.items = obj.data;
  
  state.perPage = obj.perPage || 15;
  state.page = obj.page;
  state.active = obj.active;
  state.inactive = obj.inactive;
  state.total = obj.total;
};

const SET_ACTIVE = (state, obj) => {
  state.active = obj;
};

const SET_PERMISSIONS = (state, obj) => {
  state.permissions = obj;
};

const ADD_ITEM = (state, obj) => {
  state.items = [obj, ...state.items];
};

const EDIT_ITEM = (state, obj) => {
  const items = [...state.items];
  const index = items.findIndex(p => p.pk == obj.pk);

  if (index < 0 ) {
    return;
  }

  items[index] = { ...obj };
  state.items = items;
};

const DELETE_ITEM = (state, obj) => {
  state.items = state.items.filter(p => p.pk !== obj.pk);
};

const UPDATE_PERMISSIONS = (state, obj) => {
  const items = [...state.items];
  const index = items.findIndex(p => p.pk == obj.pk);

  if (index < 0 ) {
    return;
  }

  items[index] = { ...items[index], permission_codes: obj.permission_codes };
  state.items = items;
};

export default {
  SET_ITEMS,
  ADD_ITEM,
  EDIT_ITEM,
  DELETE_ITEM,
  SET_PERMISSIONS,
  SET_ACTIVE,
  UPDATE_PERMISSIONS,
};
